import { render, staticRenderFns } from "./EditDispatch.vue?vue&type=template&id=6d6f1d16&scoped=true"
import script from "./EditDispatch.vue?vue&type=script&lang=js"
export * from "./EditDispatch.vue?vue&type=script&lang=js"
import style0 from "./EditDispatch.vue?vue&type=style&index=0&id=6d6f1d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f1d16",
  null
  
)

export default component.exports